/**
 * Normalizes a string by removing diacritics and converting to uppercase for comparison
 * @param {string} str - The string to normalize
 * @returns {string} - The normalized string
 */
export const normalizeForSearch = (str) => {
  if (!str) return '';
  
  return str
    .normalize('NFD') // Decompose diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove combining diacritics
    .toUpperCase();
};

/**
 * Check if a text contains a search term (case and diacritics insensitive)
 * @param {string} text - The text to search in
 * @param {string} searchTerm - The term to search for
 * @returns {boolean} - Whether the text contains the search term
 */
export const containsIgnoreCase = (text, searchTerm) => {
  if (!text || !searchTerm) return false;
  
  const normalizedText = normalizeForSearch(text);
  const normalizedSearch = normalizeForSearch(searchTerm);
  
  return normalizedText.includes(normalizedSearch);
};